import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WidgetTypes } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import { Popover, Tooltip } from 'antd';
import React from 'react';

import AditionalContent from './AditionalContent';
import { PopoverContainer, WidgetBox } from './styles';


type PropType = {
  data: any;
  title: string;
  id: any;
  unit: any;
  widgetID: string;
  deleteWidgetByIndex: Function;
  editWidget?: Function;
  isPreview?: boolean;
  widget?: any;
  duplicateWidget: Function;
}

function editWidget(props: any) {
  props.editWidget();
}

function duplicateWidget(props: any) {
  props.duplicateWidget();
}

function deleteWidget(props: any) {
  props.deleteWidgetByIndex(props.id, props.widgetID);
}

function renderUsersSelected(props: any) {
  if (props.widget.userIds) {
    return (
      <>
        <span className='count-user-style'>{props.widget && props.widget.userIds ? props.widget.userIds.length : 0}</span>
        <span className='span-style'>Pessoas</span>
      </>
    )
  }
  else return (
    <span className='span-style'>Todos os usuários</span>
  )
}

function popoverContent(props: any) {
  return (
    <PopoverContainer>
      <div style={{ display: 'flex' }} className="popover-row" onClick={() => editWidget(props)} >
        <div className="icon">
          <FontAwesomeIcon icon={'edit'} />
        </div>
        <div className="text">
          <p>{I18n.l('common.edit')}</p>
        </div>
      </div>

      <div style={{ display: 'flex' }} className="popover-row" onClick={() => duplicateWidget(props)}>
        <div className="icon">
          <FontAwesomeIcon icon={'clone'} />
        </div>
        <div className="text">
          <p>{I18n.l('common.duplicate')}</p>
        </div>
      </div>

      <div style={{ display: 'flex' }} className="popover-row" onClick={() => deleteWidget(props)}>
        <div className="icon">
          <FontAwesomeIcon icon={'trash'} />
        </div>
        <div className="text">
          <p>{I18n.l('common.delete')}</p>
        </div>
      </div>
    </PopoverContainer>
  )

}

function returnData(data: any, widget: any) {

  if (widget && widget.recurrence) {
    let usersObject = {}
    const usersArray = []
    for (let singleData of data) {
      if (usersObject[`${singleData.owners[0].id}`]) {
        usersObject[`${singleData.owners[0].id}`] += 1
      } else {
        usersArray.push(singleData.owners[0].id)
        usersObject[`${singleData.owners[0].id}`] = 1
      }
    }
    let returnedValue: any = usersArray.map(e => (usersObject[`${e}`] - 1))
    if (returnedValue && returnedValue.length > 0) {
      returnedValue = returnedValue.reduce((a: number, b: number) => a + b)
    }
    else {
      returnedValue = 0
    }
    return returnedValue
  }

  return data.length
}



const Counter = (props: PropType) => {
  return (
    <WidgetBox className="-counter">
      <div className="up">
        <div className="title">
          <Tooltip placement="topLeft" title={props.title}>
            {props.title}
          </Tooltip>
        </div>
        <div className="edit custom"  >
          {!props.isPreview &&
            <div className="please-disapear no-padding">
              <Popover
                placement='bottom'
                trigger="hover"
                content={popoverContent(props)}
              >
                <FontAwesomeIcon icon={"cog"} />
              </Popover>
            </div>
          }
        </div>

      </div>
      <div className="bottom">
        <AditionalContent type={WidgetTypes.COUNTER} widget={props.widget} />
        {props.data && props.widget && returnData(props.data, props.widget)}
      </div>
    </WidgetBox>
  )
}

export default Counter
